import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { addressSelectionGuideFilterFields } from "~/widgets/Filter/AddressSelectionGuideFilter/model/fields";

export const AddressSelectionGuideFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => addressSelectionGuideFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow />;
};
